// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"LDS-inputContainer-2sV5nP"};